export enum FormItemTypeDTO {
  Unknown = 0,
  Field,
  FieldsGroup,
  DateRangeFields,
  QuestionWithDetails,
  HiddenField,
  OfficeHours,
  StagedFieldsGroup,
  InferredField,
  File,
  // 10 was ReusableFieldsGroup; the API keeps the value reserved.
  ConditionalFieldsGroup = 11,
}
